import React from 'react';

const PropertyTrendsSection = ({ data }) => {
	if (!data || !data.trends || data.trends.length === 0) {
		return (
			<div className="alert alert-info">
				No trend data available for this property.
			</div>
		);
	}

	const { trends, startDate, endDate, days } = data;

	// Calculate totals across all days
	const totals = trends.reduce(
		(acc, day) => ({
			totalJobs: acc.totalJobs + day.totalJobs,
			bisTotal: acc.bisTotal + day.bisTotal,
			odTotal: acc.odTotal + day.odTotal,
			successes: acc.successes + day.successes,
			failures: acc.failures + day.failures,
		}),
		{ totalJobs: 0, bisTotal: 0, odTotal: 0, successes: 0, failures: 0 },
	);

	const avgPerDay = Math.round(totals.totalJobs / days);
	const overallSuccessRate =
		totals.totalJobs > 0
			? ((totals.successes / totals.totalJobs) * 100).toFixed(1)
			: 0;

	return (
		<div className="property-trends-section">
			{/* Summary Cards */}
			<div className="row g-3 mb-4">
				<div className="col-md-3 col-6">
					<div className="card border bg-light">
						<div className="card-body text-center">
							<div className="text-muted small">Total Jobs ({days} days)</div>
							<div className="h4 mb-0 fw-bold text-primary">
								{totals.totalJobs}
							</div>
						</div>
					</div>
				</div>
				<div className="col-md-3 col-6">
					<div className="card border bg-light">
						<div className="card-body text-center">
							<div className="text-muted small">Avg per Day</div>
							<div className="h4 mb-0 fw-bold text-info">{avgPerDay}</div>
						</div>
					</div>
				</div>
				<div className="col-md-3 col-6">
					<div className="card border bg-light">
						<div className="card-body text-center">
							<div className="text-muted small">BIS Total</div>
							<div className="h4 mb-0 fw-bold text-success">
								{totals.bisTotal}
							</div>
						</div>
					</div>
				</div>
				<div className="col-md-3 col-6">
					<div className="card border bg-light">
						<div className="card-body text-center">
							<div className="text-muted small">OD Total</div>
							<div className="h4 mb-0 fw-bold text-warning">
								{totals.odTotal}
							</div>
						</div>
					</div>
				</div>
			</div>

			{/* Success/Failure Stats */}
			<div className="card border bg-light mb-4">
				<div className="card-body">
					<h6 className="card-title">Overall Performance</h6>
					<div className="row mt-3">
						<div className="col-md-4">
							<div className="text-muted small">Total Successes</div>
							<div className="h5 text-success">{totals.successes}</div>
						</div>
						<div className="col-md-4">
							<div className="text-muted small">Total Failures</div>
							<div className="h5 text-danger">{totals.failures}</div>
						</div>
						<div className="col-md-4">
							<div className="text-muted small">Success Rate</div>
							<div className="h5 text-primary">{overallSuccessRate}%</div>
						</div>
					</div>
				</div>
			</div>

			{/* Daily Breakdown Table */}
			<div className="card border bg-light">
				<div className="card-header bg-light">
					<h6 className="mb-0">Daily Breakdown</h6>
					<small className="text-muted">
						{startDate} to {endDate}
					</small>
				</div>
				<div className="card-body p-0">
					<div className="table-responsive">
						<table className="table table-sm table-hover mb-0">
							<thead className="table-light">
								<tr>
									<th>Date</th>
									<th className="text-center">Total Jobs</th>
									<th className="text-center">BIS</th>
									<th className="text-center">OD</th>
									<th className="text-center">Unique Types</th>
									<th className="text-center">Successes</th>
									<th className="text-center">Failures</th>
								</tr>
							</thead>
							<tbody>
								{trends.map((day, index) => (
									<tr key={index}>
										<td>
											<strong>{day.date}</strong>
										</td>
										<td className="text-center">
											<span className="badge bg-primary">{day.totalJobs}</span>
										</td>
										<td className="text-center">
											<span className="badge bg-success">
												{day.bisTotal}
												{day.bisUnique > 0 && (
													<small className="ms-1">({day.bisUnique})</small>
												)}
											</span>
										</td>
										<td className="text-center">
											<span className="badge bg-warning text-dark">
												{day.odTotal}
												{day.odUnique > 0 && (
													<small className="ms-1">({day.odUnique})</small>
												)}
											</span>
										</td>
										<td className="text-center">{day.uniqueJobTypes}</td>
										<td className="text-center text-success">
											{day.successes}
										</td>
										<td className="text-center">
											{day.failures > 0 ? (
												<span className="text-danger">{day.failures}</span>
											) : (
												<span className="text-muted">0</span>
											)}
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>
	);
};

export default PropertyTrendsSection;
